import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthFormFrame, AuthLayout } from "../../components/domain/auth/AuthLayout";
import { WaitlistForm } from "../../components/domain/inputs/WaitlistForm";
import { ROUTES } from "../../route_paths";

/** Where someone without an account registers interest in the beta: the waiting-list form on the auth layout. */
export default function JoinBeta() {
  const { t } = useTranslation();
  return (
    <AuthLayout>
      <AuthFormFrame
        title={t("auth.joinBetaPage.title")}
        subtitle={t("auth.joinBetaPage.subtitle")}
        footer={
          <Button component={Link} to={ROUTES.signIn.path()} variant="text" size="small">
            {t("auth.joinBetaPage.backToSignIn")}
          </Button>
        }
      >
        <WaitlistForm />
      </AuthFormFrame>
    </AuthLayout>
  );
}
